module.exports = __webpack_public_path__ + "static/media/qrcode_pix.f97ab62f.jpeg";